
import { useAppSelector } from "@/store";
import { useLayoutState } from "@/store/layout";
import { useEffect } from "react";
import { Blocks } from "react-loader-spinner";


export default function Loader() {
    const {loading} = useAppSelector(useLayoutState);

    useEffect(() => {
        if(loading){
            document.body.style.overflow = "hidden";
        }else{
            document.body.style.overflow = "auto";
        }
    }, [loading]);

    if(!loading){
        return null;
    }

    return (
        <div
           className="flex flex-col justify-center items-center w-screen h-screen fixed top-0 left-0 bg-white bg-opacity-70 z-[999]"
        >
            <Blocks
                 visible={true}
                 width="200"
                 height="200"
                 color={"#00BFFF"}
            />
            <span className="text-center text-xl font-bold">Carregando...</span>
        </div>
    );
}